import { createAction} from "redux-actions";

export const run = createAction("RUN");
export const step = createAction("STEP");
export const reset = createAction("RESET");



// WEBPACK FOOTER //
// ./actions/interpreter.ts